import { render, staticRenderFns } from "./404Error.vue?vue&type=template&id=0062adb9&lang=html"
import script from "./404Error.vue?vue&type=script&lang=js"
export * from "./404Error.vue?vue&type=script&lang=js"
import style0 from "./404Error.vue?vue&type=style&index=0&id=0062adb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports